import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmergencyCardService {
  emergencyCardUrl:string = 'api/AdminMedicalCard/GenerateMedicalCards?MedicalCardCount=';
  constructor(private http: HttpClient) { }
  generateEmergencyCard(count:number) {
    return this.http.get(`${this.emergencyCardUrl}${count}`);
  }
}
